/**
 * Easely Validator
 * Sanitizes user input to prevent GSAP runtime errors
 */

export const validator = {
  /**
   * Ensures a value is a valid number
   */
  number: (val, fallback) => {
    const parsed = parseFloat(val);
    return isNaN(parsed) ? fallback : parsed;
  },

  /**
   * Ensures ease string is valid or returns default
   */
  ease: (val, fallback) => {
    if (!val || typeof val !== 'string') return fallback;
    // Basic check for common GSAP ease syntax
    return val.includes('.') || val === 'none' ? val : fallback;
  },

  /**
   * Prevent negative values for timing
   */
  positive: (val) => Math.max(0, val)
};